import { FC } from 'react'
import styles from '../TicketLanding.module.css'
import classNames from 'classnames'
import { Text } from '@/atoms/Text'
import { EmblaCarousel, EmblaSlide } from '@/molecules/EmblaCarousel'
import { useTranslate } from '@/utils/translate/translate-client'
import { TicketCard } from '@/views/AccountView/tabs/MyTicketsTab/components/TicketCard'
import { SimpleTicketItem } from '@/views/TicketCheckoutViews/hooks/useSimpleTicketList'

interface Props {
  tickets: SimpleTicketItem[]
  className?: string
}

export const UserMovieTickets: FC<Props> = ({ tickets, className }) => {
  const { t } = useTranslate('tickets')

  return (
    <section className={classNames('relative flex flex-col gap-4 md:mx-auto md:gap-10', className)}>
      <Text
        className={classNames('photon-title-md md:photon-heading-lg xl:photon-heading-xl', styles.layoutContainer)}
        weight="bold"
        color="white"
      >
        {t('yourMovieTickets', 'Your Movie Tickets')}
      </Text>

      <EmblaCarousel
        includeArrows
        leftArrowClassname="hidden md:block"
        rightArrowClassname="hidden md:block"
        options={{
          active: false,
          breakpoints: {
            '(min-width: 768px)': {
              active: true,
              dragFree: true,
              align: 'start',
              containScroll: 'trimSnaps',
              slidesToScroll: 1,
            },
          },
        }}
        containerClassName={classNames('flex flex-col gap-2 md:gap-6 md:flex-row', styles.layoutContainer)}
      >
        {tickets.map((ticket) => {
          if (!ticket?.id) return null

          return (
            <EmblaSlide fadeOutOfView className="w-full md:max-w-[440px]" key={ticket.id}>
              <TicketCard className="w-full" ticket={ticket} disableSkeleton={true} />
            </EmblaSlide>
          )
        })}
      </EmblaCarousel>
    </section>
  )
}
